import React, {useState, useEffect} from 'react';
import {Card} from "react-bootstrap";

import {API, graphqlOperation} from "aws-amplify";
import {getStructureImage} from './../graphql/queries';

const style = {
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    paddingBottom: '0.5em',
};

export default function GsmResultCard({sugarStructure, gsmScore, assigned, index, scale, edit, handleEditModalShow, handleSelectionChange}) {

    const [image, setImage] = useState("{base64=iVBORw0KGgoAAAANSUhEUgAAAMEAAAB4CAYAAABLh5YhAAABAElEQVR42u3TQQkAAAwDsfo33dkoLI8YOLi0DXwmAiYQAROIgAlEwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABDDnXe2hrsvixvwAAAABJRU5ErkJggg==}");

    useEffect(() => {
        const fetchImage = async () => {

            API.graphql(
                graphqlOperation(getStructureImage, {scale: scale, structure: sugarStructure})
            ).then(result => {

                setImage(result.data.getStructureImage.base64);
            });
        };

        fetchImage()
    }, [sugarStructure, scale]);

    return (
        <Card bg={assigned ? "info" : "light"}  border="secondary" className="my-1">

            <Card.Img variant="bottom" src={`data:image/png;base64, ${image.substring(8, image.length - 1)}`}/>
            <small className={assigned ? "text-white" : "text-muted"} style={style}>
                <Card.Text>
                    Score: {gsmScore.toFixed(3)}
                    {edit ?
                        <Card.Link className="float-right" href="#" onClick={(e) => {
                            e.preventDefault();
                            return handleEditModalShow();
                        }}>Edit</Card.Link>
                        :
                        <Card.Link className="float-right" href="#" onClick={(e) => {
                            e.preventDefault();
                            return handleSelectionChange(index);
                        }}>Select</Card.Link>
                    }
                </Card.Text>
            </small>
        </Card>
    );
}